import * as React from 'react';
import { connect } from 'react-redux';
import { signUp } from '../../actions/authActions';
import { Link } from 'react-router-dom';
import { LOGIN } from '../../routes/routes';
import { Form, Button, Image, InputGroup } from 'react-bootstrap';
import { avaragePassword, strongPassword, validateEmail } from './../../constants/validation';
import KPInputTextArea from '../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import './RegisterUser.css'

class RegisterUser extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            email: '',
            password: '',
            passwordTwo: '',
            passwordMatch: true,
            isStrongPassword: false,
            isAvaragePassword: false,
            isWeakPassword: false,
            mailRegex: true,
            success: false,
            hide: true,
            hideTwo: true,
            acceptedTCs: false,
            noticeType:''
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.hideSwitch = this.hideSwitch.bind(this);
        this.hideSwitchTwo = this.hideSwitchTwo.bind(this);
        this.handleToggleTC = this.handleToggleTC.bind(this);
    }

    hideSwitch = ev => {
        this.setState({ hide: !this.state.hide })
    }

    hideSwitchTwo = ev => {
        this.setState({ hideTwo: !this.state.hideTwo })
    }

    async handleToggleTC() {
        await this.setState({ acceptedTCs: !this.state.acceptedTCs });
    }

   async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;

        await this.setState({ [name]: value });
        await this.setState({ isWeakPassword: false, isAvaragePassword: false, isStrongPassword: false, noticeType:'' });

        if (this.state.password !== "") {

            if (strongPassword.test(this.state.password)) {
                await this.setState({ isStrongPassword: true, noticeType: 'success', noticeMessage:'The force is strong with this 1. Please continue.' });
            } else if (avaragePassword.test(this.state.password)) {
                await this.setState({ isAvaragePassword: true, noticeType: 'warning', noticeMessage: 'You’re getting warmer… Add some lower/upper case characters.' });
            } else {
                await this.setState({ isWeakPassword: true, noticeType: 'error', noticeMessage: "Woah, that's too easy! Your password should be at least 8 characters and contain uppercase and lowercase letters, numbers, and a special character." });
            }
        }
    }

    async handleRegister(e: any) {
        const { password, passwordTwo, email } = this.state;
        e.preventDefault();

        if (validateEmail.test(email)) {
            this.setState({ mailRegex: true });
            if (this.state.isAvaragePassword || this.state.isStrongPassword) {
                this.setState({ passwordRegex: true });
                if (password === passwordTwo) {
                    await this.setState({ submitted: true, passwordMatch: true });
                    await this.props.signUp(this.state);
                    if (!this.props.authError) {
                        await this.setState({ success: true });
                    }
                }
                else {
                    await this.setState({ passwordMatch: false });
                }
            }
        }
        else {
            await this.setState({ mailRegex: false });
        }
    }

    render() {
        return (
            <div>
                <KPInputTextArea
                    id="RegisterInputEmail"
                    name="email"
                    type="email"
                    className="mb-15px"
                    label={"Email"}
                    showLabelAfterSelection={true}
                    value={this.state.email}
                    notice={!this.state.mailRegex}
                    noticeType={"error"}
                    noticeMessage={"A valid email is required"}
                    successTick={false}
                    required={false}
                    readOnly={false}
                    autoFocus={false}
                    minLength={10}
                    maxLength={false}
                    disabled={false}
                    form="mainform"
                    handleChange={(e) => this.handleChange(e)}
                />
               
                <KPInputTextArea
                    id="RegisterInputPassword"
                    name="password"
                    type="password"
                    className="mb-15px"
                    label={"Password"}
                    showLabelAfterSelection={true}
                    value={this.state.password}
                    notice={this.state.noticeType === "" ? false :true}
                    noticeType={this.state.noticeType}
                    noticeMessage={this.state.noticeMessage}
                    successTick={false}
                    required={false}
                    readOnly={false}
                    autoFocus={false}
                    minLength={10}
                    maxLength={false}
                    disabled={false}
                    form="mainform"
                    handleChange={(e) => this.handleChange(e)}
                />

                <div>
                    <KPInputTextArea
                        id="LoginInputPassword"
                        name="passwordTwo"
                        type="password"
                        className="mb-15px"
                        label={"Re-type password"}
                        showLabelAfterSelection={true}
                        value={this.state.passwordTwo}
                        notice={!this.state.passwordMatch}
                        noticeType={"error"}
                        noticeMessage={"Oops, your passwords don't match. Please try again?"}
                        successTick={false}
                        required={false}
                        readOnly={false}
                        autoFocus={false}
                        minLength={10}
                        maxLength={false}
                        disabled={false}
                        form="mainform"
                        handleChange={(e) => this.handleChange(e)}
                    />
                </div>
              
                <div className="row ml-24px">
                    {this.props.profile.countryId === 244 && 
                        <div className="row w-100">
                            <div className="col-1 nopa">
                                <img className="pr-10px" src="./images/icon-whatsapp-nugreen.svg" alt="" title="" />
                            </div>
                            <div className="col-11 nopa">
                            <p className="byClickNext">By signing up, you agree to receive our WhatsApp notifications. (You can opt out at any time, though.)</p>
                            </div>
                        </div>}
                        <div className="row w-100">
                        <div className="col-2 nopa">
                            <label className="switch">
                                <input type="checkbox" onClick={this.handleToggleTC} />
                                <span id="registerCheckbox" className="slider-signup round"></span>
                            </label>
                        </div>
                        {this.props.profile.countryId === 244 &&
                            <div className="col-10 nopa">
                                <p className="switch-normal nopa ml-12px mb-20px">I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/terms-and-conditions/">King Price’s T’s & C’s</a> and <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/privacy-policy/">POPIA policy</a>.</p>
                            </div>}
                        {this.props.profile.countryId === 157 &&
                            <div className="col-10 nopa">
                            <p className="switch-normal nopa ml-12px mb-20px">I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.na/Home/terms-and-conditions/">King Price’s T’s & C’s</a>.</p>
                            </div>}
                           </div>
                </div>
                <Button type="button" className="btn btn-solid-green btn-lg btn-sign-up" disabled={!this.state.acceptedTCs} onClick={this.handleRegister} id="Register">Sign up</Button>
                <div className="mt-3">
                    <p> {this.props.profile.countryId != 157 ? "Already a client?" : "Already registered?"} <Link className="Uh-oh-I-forgot-my-p" id="SignUp" to={LOGIN}>Log in</Link></p>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        authError: state.auth.authError,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        signUp: (creds: any) => dispatch(signUp(creds))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser);